import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'duration' }) // log variable into the console

export class DurationFormatPipe implements PipeTransform
{
    transform(value: any, arg1: 's' | 'ms' = 's', arg2: 'mmss' | 'hhmmss' | 'ddhhmmss' | 'ddhhmmssLong' = 'hhmmss'): any
    {
        let days: any;
        let seconds: any;
        let minutes: any;
        let hours: any;

        if (arg1 === 'ms') {
            seconds = Math.floor((value / 1000) % 60);
            minutes = Math.floor(((value / (1000 * 60)) % 60));
            hours = Math.floor((value / (1000 * 60 * 60)));
            days = Math.floor((value / (1000 * 60 * 60 * 24)));
        } else if (arg1 === 's') {
            seconds = Math.floor((value % 60));
            minutes = Math.floor(((value / 60) % 60));
            hours = Math.floor(((value / 60) / 60));
            days = Math.floor((value / (1000 * 60 * 60 * 24)));
        } else {
            return value;
        }

        let result = `${seconds}s`;

        if (minutes > 0) {
            result = `${minutes}m ${result}`;
        }

        if (hours > 0) {
            result = `${hours}h ${result}`;
        }

        if (days > 0) {
            result = `${days}days ${result}`;
        }

        return result;
    }
}
